import { getGridStepDenominator } from './synthModel.js'

export const SYNTH_TICKS_PER_QUARTER = 480
export const SYNTH_REFERENCE_BPM = 120

const SYNTH_NOTE_VALUE_BY_TICKS = new Map([
  [1920, '1/1'], [1440, '1/2.'], [1280, '1/1T'],
  [960, '1/2'], [720, '1/4.'], [640, '1/2T'],
  [480, '1/4'], [360, '1/8.'], [320, '1/4T'],
  [240, '1/8'], [180, '1/16.'], [160, '1/8T'],
  [120, '1/16'], [90, '1/32.'], [80, '1/16T'],
  [60, '1/32'], [40, '1/32T'],
])

export function ticksToNoteValue(durationTicks) {
  const ticks = Number(durationTicks)
  if (!Number.isFinite(ticks) || ticks <= 0) return '0 ticks'
  return SYNTH_NOTE_VALUE_BY_TICKS.get(ticks) ?? `${Number.isInteger(ticks) ? ticks : Number(ticks.toFixed(3))} ticks`
}

export function quarterNoteMs(bpm) {
  return 60000 / clampBpm(bpm)
}

export function ticksToMs(ticks, bpm) {
  return Math.max(0, Number(ticks) || 0) / SYNTH_TICKS_PER_QUARTER * quarterNoteMs(bpm)
}

export function msToTicks(ms, bpm) {
  return Math.max(0, Number(ms) || 0) / quarterNoteMs(bpm) * SYNTH_TICKS_PER_QUARTER
}

export function noteDivisionToTicks(division) {
  return SYNTH_TICKS_PER_QUARTER * (4 / getGridStepDenominator(division))
}

export function noteDivisionToMs(division, bpm) {
  return ticksToMs(noteDivisionToTicks(division), bpm)
}

export function eventDurationMs(event, bpm) {
  return ticksToMs(event?.durationTicks ?? event?.durationMs, bpm)
}

export function sequenceDurationMs(sequence, bpm) {
  let legacyCursor = 0
  const endTick = (sequence ?? []).reduce((max, event) => {
    const duration = Math.max(0, Number(event?.durationTicks) || 0)
    const start = Number.isFinite(Number(event?.startTick)) ? Number(event.startTick) : legacyCursor
    legacyCursor = start + duration
    return Math.max(max, start + duration)
  }, 0)
  return ticksToMs(endTick, bpm)
}

function clampBpm(bpm) {
  return Math.min(240, Math.max(40, Number(bpm) || SYNTH_REFERENCE_BPM))
}
